import { dividerRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const Divider = styled('div', dividerRecipe);
export type DividerProps = HTMLStyledProps<typeof Divider>;
